import { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Button, CardMedia, Container, createTheme, CssBaseline, Divider, FormControlLabel, Grid, Switch, TextField, ThemeProvider, Typography } from '@mui/material'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Telefono } from '../../modules/ui/Telefono';
import { SelectCustom } from '../../modules/ui/SelectCustom';
import { SelectCustomWithOther } from '../../modules/ui/SelectCustomWithOther';
import { SelectCountryAndRegion } from '../../modules/ui/SelectCountryAndRegion';
import { useForm } from 'react-hook-form';
import { isEmail, isEmptyValue } from '../../../utils/validations';
import { generateRef } from "../../../helpers/generateRef";
import Swal from 'sweetalert2';
import moment from 'moment';
import { FileUploadCustom } from '../../modules/ui/FileUploadCustom';
import { CustomDialog } from '../../modules/dialogs/CustomDialog';
import { ParticipantWorkCustom } from '../../modules/ui/ParticipantWorkCustom';
import { postIn } from '../../../services/crudCustom';
import { renderToString } from 'react-dom/server';
import { setEmailBodyGeneral } from '../../../helpers/setEmailBodyGeneral';
import { sendEmail } from '../../../services/sendEmail';
import { createButton } from '../../../helpers/html/createButton';
import { setBodyFirstMail } from './emails/bodies';
import { compareAsc, isBefore, isToday } from 'date-fns';
import { MuiTelInput } from 'mui-tel-input';


//* Identificador del evento: si éste no tiene proyecto interno, el id se forma con los 5 primeros caracteres del nombre del evento como numero
const eventId = 74622;
const urlLogo = "https://aena.mx/images/nicepage-images/80f8a68a08b4341bcc455d466709dc31.png";
const eventLogo = "https://eventos.cibnor.mx/intranet/img/logo_sina2025.png";

export const Sina2025 = () => {

    //* State para los controles custom que no pueden validarse por useForm
    const [formValues, setFormValues] = useState({
        partGenero: '',
        partTelefono: '',
        profPais: '',
        profEstado: '',
        tipoRegistro: '',
        tipoRegistroDocURL: '',

        modalidad: '',
        trabajos: [],

        concursoPoster: false,
        concursoFoto: false,
        // concursoFotoDocsURL: '',
        // 'prefix': 5 primeros caracteres del nombre del evento como numero, 
        // tomando los correspondientes digitos en un telefono.
        registroReferencia: generateRef ({ prefix: eventId }),
    });
    let { 
        partGenero,
        partTelefono, 
        profPais,
        profEstado,
        tipoRegistro,
        tipoRegistroDocURL,

        modalidad,
        trabajos,

        concursoPoster,
        concursoFoto,
        concursoFotoDocsURL,

        registroReferencia,
    } = formValues;

    const [isStudent, setIsStudent] = useState(false);
    const [isSponsor, setIsSponsor] = useState(false);

    const [uploadingFile, setUploadingFile] = useState(false);
    const [sendingForm, setSendingForm] = useState(false);

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();


    // Cada que cambia el valor en un control de formulario que no sea validado con useForm
    const handleInputChange = ({ target }) => {
        setFormValues({ ...formValues, [target.name]: target.value });
    };

    const handleTelefonoChange = (newValue) => {
        // console.log(newValue.length, newValue);
        setFormValues({ ...formValues, partTelefono: newValue });
    }

    const handleTipoRegistroChange = ({ target }) => {
        const { value } = target;

        value.toLowerCase().includes('estudiante')
        ? setIsStudent(true)
        : setIsStudent(false)

        value.toLowerCase().includes('patrocinador')
        ? setIsSponsor(true)
        : setIsSponsor(false)

        setFormValues({ ...formValues, [target.name]: target.value });
    };
    
    // Cada que se elige un archivo como comprobante de estudiante
    const handleStudentDocumentUploaded = ({ exito, mensaje, data }) => {

        if (exito === 0) {
            console.log('Error', mensaje);
            Swal.fire({
                title: '¡Error!',
                text: 'Por favor intenta mas tarde / Please, try again later.',
                icon: 'error',
                footer: `Tip: ${ mensaje || 'Check console.'}`
            })
            return;
        }

        setFormValues({ 
            ...formValues, 
            tipoRegistroDocURL: `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ data }`, 
        });
    }
    
    // Cada que se elige un archivo para el concurso de foto
    const handleConcursoFotoUploaded = ({ exito, mensaje, data }) => {

        if (exito === 0) {
            console.log('Error', mensaje);
            Swal.fire({
                title: '¡Error!',
                text: 'Por favor intenta mas tarde / Please, try again later.',
                icon: 'error',
                footer: `Tip: ${ mensaje || 'Check console.'}`
            })
            return;
        }

        setFormValues({ 
            ...formValues, 
            concursoFotoDocsURL: `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ data }`, 
        });
    }

    const handleParticipantWorkEdited = (w) => {
        const workToEditIndex = formValues.trabajos.findIndex(t => t.id === w.id);

        // No existe, agrégalo
        if (workToEditIndex < 0) {
            formValues.trabajos.push(w);
            return;
        } 

        // Si existe, actualízalo
        formValues.trabajos[workToEditIndex] = w;
    }


    //* Si esto se ejecuta significa que los datos en useForm ya estan validados
    // Al enviar formulario a traves de useForm
    const onSubmit = async (useFormData) => {
        //* Validar los campos que no estan en useForm

        //Genero
        if (isEmptyValue(partGenero)) {
            Swal.fire({ title: 'Datos Personales / Personal Info', icon: 'error', 
                text: '"Género" esta vacío / "Gender" empty.' 
            })
            return;
        }
        //Pais
        if (isEmptyValue(profPais)) {
            Swal.fire({ title: 'Datos Profesionales / Professional Info', icon: 'error', 
                text: '"País" esta vacío / "Country" is empty.' 
            })
            return;
        }
        //Puesto / Ocupación
        if (isEmptyValue(tipoRegistro)) {
            Swal.fire({ title: 'Datos Profesionales / Professional Info', icon: 'error', 
                text: '"Ocupación o Puesto" esta vacío / "Position" is empty.' 
            })
            return;
        }

        //* Validaciones condicionales
        //Si es estudiante debe agregar su credencial
        if (isStudent && isEmptyValue(tipoRegistroDocURL)) {
            Swal.fire({ title: 'Datos Profesionales / Professional Info', icon: 'error', 
                text: '"Credencial" esta vacío / "Credential" is empty.',
                footer: 'Anexa un documento / Add a document' 
            })
            return;
        }

        //Si no es patrocinador debe indicar modalidad
        if (tipoRegistro !== 'Patrocinador' && isEmptyValue(modalidad)) {
            Swal.fire({ title: 'Participación / Participation', icon: 'error', 
                text: '"Modalidad" esta vacío / "Modality" is empty.' 
            })
            return;
        }

        // Si es ponente invitado
        if (modalidad === 'Invitado') {

            if (trabajos.length === 0) {
                Swal.fire({ title: 'Participación / Participation', icon: 'error', 
                    text: 'Información de su trabajo incompleta / Work information incomplete.',
                })
                return;
            }

            for (const trabajo of trabajos) {
                
                // El titulo del trabajo
                if (trabajo.title === '') {
                    Swal.fire({ title: 'Participación / Participation', icon: 'error', 
                        text: 'Título de su trabajo pendiente / Work title missing.',
                    })
                    return;
                }

                if (trabajo.authors.length === 0) {
                    Swal.fire({ title: 'Participación / Participation', icon: 'error', 
                        text: 'Autor de su trabajo pendiente / Work author missing.',
                    })
                    return;
                }

                for (const author of trabajo.authors) {
                    console.log(author);
                    if (author.names === '' ||
                        author.lastnames === '' ||
                        author.institution === '' ||
                        author.email === ''
                    ) {
                        Swal.fire({ title: 'Participación / Participation', icon: 'error', 
                            text: 'Información de autor pendiente / Author information missing.',
                        })
                        return;
                    }
                    
                }
            }
        }

        // Si es participante
        if (modalidad === 'Participante') {

            if (trabajos.length === 0) {
                Swal.fire({ title: 'Participación / Participation', icon: 'error', 
                    text: 'Información de su trabajo incompleta / Work information incomplete.',
                })
                return;
            }

            for (const trabajo of trabajos) {
                
                // El titulo del trabajo
                if (trabajo.title === '') {
                    Swal.fire({ title: 'Participación / Participation', icon: 'error', 
                        text: 'Título de su trabajo pendiente / Work title missing.',
                    })
                    return;
                }
                // El titulo del trabajo
                if (trabajo.url === '') {
                    Swal.fire({ title: 'Participación / Participation', icon: 'error', 
                        text: 'Resumen de su trabajo pendiente / Work resume missing.',
                    })
                    return;
                }

                if (trabajo.authors.length === 0) {
                    Swal.fire({ title: 'Participación / Participation', icon: 'error', 
                        text: 'Autor de su trabajo pendiente / Work author missing.',
                    })
                    return;
                }

                for (const author of trabajo.authors) {
                    console.log(author);
                    if (author.names === '' ||
                        author.lastnames === '' ||
                        author.institution === '' ||
                        author.email === ''
                    ) {
                        Swal.fire({ title: 'Participación / Participation', icon: 'error', 
                            text: 'Información de autor pendiente / Author information missing.',
                        })
                        return;
                    }
                    
                }
            }
        }


        //* 
        //* Los archivos de credencial de estudiante y 
        //* resumenes anexados se suben al seleccionarlos
        //* 


        //* Los campos que no estan en useForm y campos de control
        const infoAdicional = {
            partGenero,
            partNacionalidad: useFormData.partNacionalidad || '',
            partTelefono,

            profInstitucion: useFormData.profInstitucion || '',
            profDireccion: useFormData.profDireccion || '',
            profGrado: useFormData.profGrado || '',
            profPais,
            profEstado,
            profGrado: useFormData.profGrado || '',
            modalidad,
            trabajos,
    
            concursoPoster: concursoPoster ? '1' : '0',
            concursoFoto: concursoFoto ? '1' : '0',
            concursoFotoDocsURL,

            isStudent: isStudent ? '1' : '0',
            isSponsor: isSponsor ? '1' : '0',
        }
        // console.log({concursoPoster, concursoFoto, isStudent, isSponsor});
        // console.log('--- infoAdicional');
        // Object.keys(infoAdicional).forEach(k => console.log(`${ k }:`, infoAdicional[k]));

        //* Estructura que requiere el API para guardar el registro del participante
        const recordToStore = {
            partApellidoPaterno: useFormData.partApellidoPaterno || '',
            partApellidoMaterno: useFormData.partApellidoMaterno || '',
            partNombres: useFormData.partNombres || '',
            partCorreo: useFormData.partCorreo || '',
            partPais: '',
            partEstado: '',
            tipoRegistro,
            tipoRegistroDocURL,
            registroClaveProyecto: eventId,
            registroFecha: moment( Date.now() ).format('YYYY-MM-DDTHH:mm:ss'),
            registroReferencia,
            infoAdicional: JSON.stringify(infoAdicional), //'{ contenido adicional en formato stringified }'
            eventoId: '29'
        }
        console.log('recordToStore', recordToStore);
        
        setSendingForm(true);

        //* Guardar en la base de datos el registro
        const { exito, mensaje, data } = await postIn({ table: 'RegistroGeneral', values: recordToStore });
        console.log({ exito, mensaje, data });
        
        //* Informar el resultado en caso de error
        if (exito === 0) {
            console.log('Error', mensaje);
            setSendingForm(false);
            Swal.fire({
                title: '¡Error!',
                text: 'Por favor intenta mas tarde / Please, try again later.',
                icon: 'error',
                footer: `Tip: ${ mensaje || 'Check console.'}`
            })
            return;
        }


        //* Armar el correo de acuse y enviarlo
        const datosRegistro = {
            tituloEvento: 'Simposio Internacional en Nutrición Acuícola',
            correoEvento: 'sina2025@cibnor.mx',
            urlLogo: eventLogo,
            modalidad,
        }
        
        let extraContent = '';
        
        // Si es patrocinador, se le muestra el enlace para comprobar el pago realizado 
        if (tipoRegistro === 'Patrocinador') {
            extraContent += createButton(`/sina2025/comprobar-pago/${ formValues.registroReferencia }`, 'Subir comprobante de pago / Upload proof of payment');
        }

        // Si no es patrocinador ni asistente, se le muestra el enlace para editar su registro
        if (tipoRegistro !== 'Patrocinador' && modalidad === 'Participante') {
            extraContent += createButton(`/sina2025/trabajos/edicion?id=${ formValues.registroReferencia }`, 'Gestionar trabajos / Works management');
        }

        // Si no es patrocinador, se le muestra el enlace para concurso a foto
        if (tipoRegistro !== 'Patrocinador') {
            extraContent += createButton(`/sina2025/concurso-fotografia/${ formValues.registroReferencia }`, '¡CONCURSO DE FOTO! / PHOTO CONTEST!');
        }

        // Si no es patrocinador, se le muestra el enlace para concurso a foto
        if (modalidad === 'Asistente' || modalidad === 'Participante') {
            extraContent += createButton(`/sina2025/comprobar-pago/${ formValues.registroReferencia }`, 'Subir comprobante de pago / Upload proof of payment');
        }

        

        const msgbody = renderToString( 
            setBodyFirstMail({ 
                datosParticipante: recordToStore, 
                datosRegistro, 
                contenidoExtra: extraContent,
            })
        );

        // - Se genera el cc
        let toccAddresses = (process.env.REACT_APP_TOBCC_FACTURACION !== '') ? datosRegistro.correoEvento : '';

        const emailObj = {
            "toemail": useFormData.partCorreo,
            "subject": `Registro en línea | ${ datosRegistro.tituloEvento }`,
            "message": msgbody,
            "replyto": datosRegistro.correoEvento,
            "tocc": toccAddresses,
            "tobcc": 'eventos.cibnor@cibnor.mx',
        };
        // console.log({emailObj});

        const emailResult = await sendEmail(emailObj);
        console.log(emailResult);
        
        setSendingForm(false);

        Swal.fire({
            title: 'Formulario enviado / Form send',
            text: 'Consulte su correo para mayor información / Check your email for more information.',
            icon: 'success',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
        })

    }


    // useEffect(() => {
    //     const todayDate = new Date();
    //     const limitDate = new Date(2025, 9, 16);
    //     console.log({limitDate});
    //     const onTime = isBefore(todayDate, limitDate)
    //     console.log({onTime});

    //     if (!onTime) {
    //         Swal.fire({
    //             title: "¡Gracias! / Thank you!",
    //             text: 'La fecha límite de registro ha sido superada / Registration date expired.',
    //             icon: 'info',
    //             showConfirmButton: false,
    //             allowEscapeKey: false,
    //             allowOutsideClick: false,
    //         })
    //     }
    // }, [ ])
    

    return (
        <ThemeProvider theme={createTheme()}>
            <Container component='main' maxWidth='sm'>
            <CssBaseline />

            <CustomDialog title='Cargando archivo...' show={ uploadingFile } />
            <CustomDialog title='Por favor espere / Please wait' show={ sendingForm } />

            <Box sx={{ mt: 2, mb: 8, display: 'flex', flexDirection: "column", alignItems: "center" }} >
                <Box display='flex' flexDirection='row'>
                    <CardMedia
                        alt={ 'tile.label' }
                        component="img"
                        className='fadeIn'
                        image='https://aena.mx/images/nicepage-images/80f8a68a08b4341bcc455d466709dc31.png'
                        sx={{ position: 'relative', width: '100px', height: '100%' }}
                        style={{ objectFit: 'contain'}}
                    />
                    <CardMedia
                        alt={ 'tile.label2' }
                        component="img"
                        className='fadeIn'
                        image={ eventLogo }
                        sx={{ position: 'relative', width: '108px', height: '100%' }}
                        style={{ objectFit: 'contain'}}
                    />
                </Box>
                <Typography fontSize={ 26 }>Simposio Internacional en Nutrición Acuícola</Typography>
                <Typography variant='h6'>Registro en línea / Signin</Typography>

                {/* Inicio del formulario */}
                <form onSubmit={ handleSubmit(onSubmit) }>
                    <Box py={ 2 }>
                        {/* 
                        //* Datos Personales
                        */}
                        <Accordion defaultExpanded={ true } elevation={ 2 }>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight={ 100 } fontSize={ 20 }>
                                    Datos Personales / Personal Info
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="partApellidoPaterno"
                                            label="Apellido paterno / Last name"
                                            name="partApellidoPaterno"
                                            size="small"
                                            onChange={ ({ target }) => setValue('partApellidoPaterno', target.value) }
                                            variant='filled'
                                            { 
                                                ...register('partApellidoPaterno', {
                                                    required: 'Este campo es requerido',
                                                }) 
                                            }
                                            error={ !!errors.partApellidoPaterno }
                                            helperText={ errors.partApellidoPaterno?.message }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="partApellidoMaterno"
                                            label="Apellido materno / Mother last name"
                                            name="partApellidoMaterno"
                                            size="small"
                                            onChange={ ({ target }) => setValue('partApellidoMaterno', target.value) }
                                            variant='filled'
                                            { ...register('partApellidoMaterno') }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="partNombres"
                                            label="Nombres / Name"
                                            name="partNombres"
                                            size="small"
                                            onChange={ ({ target }) => setValue('partNombres', target.value) }
                                            variant='filled'
                                            { 
                                                ...register('partNombres', {
                                                    required: 'Este campo es requerido',
                                                }) 
                                            }
                                            error={ !!errors.partNombres }
                                            helperText={ errors.partNombres?.message }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="partCorreo"
                                            label="Correo electrónico / Email"
                                            name="partCorreo"
                                            size="small"
                                            onChange={ ({ target }) => setValue('partCorreo', target.value) }
                                            variant='filled'
                                            { 
                                                ...register('partCorreo', {
                                                    required: 'Este campo es requerido',
                                                    validate: isEmail
                                                }) 
                                            }
                                            error={ !!errors.partCorreo }
                                            helperText={ errors.partCorreo?.message }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SelectCustomWithOther 
                                            parentCallback={handleInputChange}
                                            name={ 'partGenero' }
                                            label={ 'Género / Gender' }
                                            options={[
                                                {value:'Masculino', label:'Masculino / Male'},
                                                {value:'Femenino', label:'Femenino / Female'},
                                            ]}
                                            value={ partGenero }
                                            variant='filled'
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField 
                                            fullWidth
                                            id="partNacionalidad"
                                            label="Nacionalidad / Nationality"
                                            name="partNacionalidad"
                                            size="small"
                                            onChange={ ({ target }) => setValue('partNacionalidad', target.value) }
                                            variant='filled'
                                            {...register('partNacionalidad', { required: 'Este campo es requerido' })}
                                            error={ !!errors.partNacionalidad }
                                            helperText={ errors.partNacionalidad?.message }
                                        />
                                    </Grid>  
                                    {/* <Grid item xs={12}>
                                        <Telefono
                                            parentCallback={ handleInputChange }
                                            name={ 'partTelefono' }
                                            label={ 'Teléfono / Phone number' }
                                            variant='filled'
                                        />
                                    </Grid> */}
                                    <Grid item xs={12}>
                                        <MuiTelInput 
                                            value={ partTelefono } 
                                            label='Teléfono / Phone number'
                                            onChange={ handleTelefonoChange } 
                                            focusOnSelectCountry
                                            // disableFormatting
                                            defaultCountry="MX"
                                            variant="filled" 
                                        />
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        {/* 
                        //* Datos profesionales
                        */}
                        <Accordion defaultExpanded={ true } elevation={ 2 }>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight={ 100 } fontSize={ 20 }>
                                    Datos profesionales / Professional Info
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="profInstitucion"
                                            label="Institución / Institution"
                                            name="profInstitucion"
                                            size="small"
                                            onChange={ ({ target }) => setValue('profInstitucion', target.value) }
                                            variant='filled'
                                            {...register('profInstitucion', { required: 'Este campo es requerido' })}
                                            error={ !!errors.profInstitucion }
                                            helperText={ errors.profInstitucion?.message }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="profDireccion"
                                            label="Dirección institucional / Address"
                                            name="profDireccion"
                                            size="small"
                                            onChange={ ({ target }) => setValue('profDireccion', target.value) }
                                            variant='filled'
                                            {...register('profDireccion', { required: 'Este campo es requerido' })}
                                            error={ !!errors.profDireccion }
                                            helperText={ errors.profDireccion?.message }
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SelectCountryAndRegion 
                                            parentCallback={ 
                                                ({ country, region }) => setFormValues({ ...formValues, profPais: country, profEstado: region }) 
                                            } 
                                            variant='filled' 
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <SelectCustom
                                            parentCallback={ handleTipoRegistroChange }
                                            name={ 'tipoRegistro' }
                                            label={ 'Ocupación o Puesto / Position' }
                                            options={[
                                                {value:'Estudiante Licenciatura', label: 'Estudiante Licenciatura / Undergraduate student'},
                                                {value:'Estudiante Maestría', label: 'Estudiante Maestría / Masters student'},
                                                {value:'Estudiante Doctorado', label: 'Estudiante Doctorado / PhD student'},
                                                {value:'Posdoctorado', label: 'Posdoctorado / Postdoc'},
                                                {value:'Investigador', label: 'Investigador / Researcher'},
                                                {value:'Profesional', label: 'Profesional / Professional'},
                                                {value:'Patrocinador', label: 'Patrocinador / Sponsor'},
                                            ]}
                                            value={ tipoRegistro }
                                            variant='filled'
                                        />
                                    </Grid>
                                    <Grid item xs={12} display={ isStudent ? 'flex' : 'none' }>
                                        <TextField
                                            fullWidth
                                            id="profGrado"
                                            label="Grado / Degree"
                                            name="profGrado"
                                            size="small"
                                            onChange={ ({ target }) => setValue('profGrado', target.value) }
                                            variant='filled'
                                            { ...register('profGrado') }
                                        />
                                    </Grid>
                                    <Grid item xs={12} display={ isStudent ? 'flex' : 'none' }>
                                        <FileUploadCustom 
                                            helperText='Anexar credencial en formato PDF / Add credential in PDF format'
                                            parentCallback={ handleStudentDocumentUploaded }
                                            parentWaitingCallback={ (val) => setUploadingFile(val) }
                                            saveFileAs= { `${ registroReferencia }_credencial` }
                                            validTypes ={ ['pdf'] }
                                            variant='standard'
                                        />
                                    </Grid>
                                    
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        {/* 
                        //* Participación
                        */}
                        <Accordion 
                            className='fadeIn'
                            defaultExpanded={ true } 
                            elevation={2} 
                            sx={{ display: isSponsor ? 'none' : 'block' }}
                        >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography fontWeight={ 100 } fontSize={ 20 }>
                                Participación / Participation
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <SelectCustom
                                            parentCallback={ handleInputChange }
                                            name={ 'modalidad' }
                                            label={ 'Modalidad / Modality' }
                                            options={[
                                                {value:'Asistente', label: 'Asistente / Attendant'},
                                                // {value:'Participante', label: 'Participante / Participant'},
                                                {value:'Invitado', label: 'Ponente invitado / Guest speaker'},
                                            ]}
                                            value={ modalidad }
                                            variant='filled'
                                        />
                                    </Grid>

                                    <Grid item xs={12} className='fadeIn' flexDirection='column' display={ modalidad === 'Participante' ? 'flex' : 'none' }>
                                        <Typography fontSize={ 14 } fontStyle='italic' color='blue' align='center' pt={ 2 }>
                                            Trabajos (máximo 2) / Works (max 2)
                                        </Typography>
                                        
                                        <Grid item xs={12}>
                                            <Typography variant='h6'>Trabajo 1</Typography>
                                        </Grid>
                                        <ParticipantWorkCustom 
                                            ownerId={ registroReferencia }
                                            parentCallback={ e => handleParticipantWorkEdited(e) }
                                            status={ 'entregado' }
                                            workFile={ true }
                                            keywords={ true }
                                        />
                                        <Grid item xs={12}>
                                            <Typography variant='h6'>Trabajo 2</Typography>
                                        </Grid>
                                        <ParticipantWorkCustom 
                                            ownerId={ registroReferencia }
                                            parentCallback={ e => handleParticipantWorkEdited(e) }
                                            status={ 'entregado' }
                                            workFile={ true }
                                            keywords={ true }
                                        />
                                    </Grid>

                                    <Grid item xs={12} className='fadeIn' display={ modalidad === 'Invitado' ? 'flex' : 'none' }>
                                        <ParticipantWorkCustom 
                                            ownerId={ registroReferencia }
                                            parentCallback={ e => handleParticipantWorkEdited(e) }
                                            status={ 'aceptado' }
                                        />
                                    </Grid>
                                    <Grid item xs={12}><Divider /></Grid>
                                    <Grid item xs={12}>
                                        <Typography variant='h6'>Concursos / Contests</Typography>
                                    </Grid>
                                    <Grid item xs={12} display={ (isStudent && modalidad !== 'Asistente') ? 'flex' : 'none' }>
                                        <FormControlLabel
                                            control={
                                                <Switch 
                                                    color='primary' 
                                                    checked={ concursoPoster } 
                                                    onChange={ ({ target }) => setFormValues({ ...formValues, concursoPoster: target.checked }) }
                                                />
                                            }
                                            label={  
                                                <Typography>
                                                    ¿Participará en el concurso de cartel electrónico? / Will you participate in the e-poster contest?
                                                </Typography> 
                                            }
                                            sx={{ mb: 1 }} 
                                        />  
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={
                                                <Switch 
                                                    color='primary' 
                                                    checked={ concursoFoto } 
                                                    onChange={ ({ target }) => setFormValues({ ...formValues, concursoFoto: target.checked }) }
                                                />
                                            }
                                            label={  
                                                <Typography>
                                                    ¿Participará en el concurso de fotografía científica? / Will you participate in the scientific photography contest?
                                                </Typography> 
                                            }
                                            sx={{ mb: 1 }} 
                                        />  
                                    </Grid>

                                    <Grid item xs={12} flexDirection='column' display={ concursoFoto ? 'flex' : 'none' }>
                                        {/* <TextField
                                            fullWidth
                                            id="concursoFotoDocsURL"
                                            helperText='URL de la carpeta / Folder URL'
                                            label="Google Drive"
                                            name="concursoFotoDocsURL"
                                            size="small"
                                            onChange={ handleInputChange }
                                            variant='filled'
                                        />
                                        <Typography fontStyle='italic' fontSize={ 14 } align='center' color='blue'>
                                        Ingresa el URL de la carpeta antes del 15 de octubre.
                                        </Typography> 
                                        <Typography fontStyle='italic' fontSize={ 14 } align='center' color='blue'>
                                        Add the folder URL before oct 15th.
                                        </Typography>  */}
                                        <Typography fontStyle='italic' fontSize={ 14 } color='blue'>
                                        Enviaremos a su correo el enlace para cargar sus archivos. / We will send by email a link to upload your files.
                                        </Typography> 
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        
                        <Box py={ 2 }>
                            <Button 
                                type='submit'
                                color='primary' 
                                onClick={ () => {
                                    console.log(formValues);
                                    // Object.keys(formValues).forEach(
                                    //     k => console.log(`${ k }:`, formValues[k])
                                    // );
                                }}
                                fullWidth
                                variant='contained'
                            >
                                Enviar
                            </Button>
                        </Box>
                    </Box>
                </form>
                                    
                {/* Footer */}
                <Grid container spacing={2} sx={{ pt: 8, pb: 2 }}>
                    <Grid item xs={12}>
                        <Divider sx={{ color: 'blue' }}/>
                        <Typography gutterBottom sx={{ fontSize:'9px', textDecorationLine: 'none' }} paragraph align="right" color="text.secondary">
                            <strong>Centro de investigaciones Biológicas del Noroeste S.C.</strong><br />
                            Instituto Politécnico Nacional 195, Playa Palo de Santa Rita Sur.<br />
                            La Paz, B.C.S., México; C.P. 23096, Tel:(52) (612) 123-8484<br />
                            <a href="https://www.cibnor.gob.mx/proteccion-datos-personales" target="_blank" rel="noreferrer" >Política de privacidad</a>
                        </Typography >
                    </Grid>
                </Grid>
            </Box>

            </Container>
        </ThemeProvider>
    )
}

